import React, { useState, useEffect, memo } from 'react'
import { OPERACIONES_OPERACION, VALUES } from 'utils/constants'
import TableCell from '../../commons/TableCell'
import Active from '../../commons/Active'
import Inactive from '../../commons/Inactive'
import ResultsTable from '../../ResultsTable'
import { useHasOperation } from 'hooks/useHasOperation'

const OperationTable = ({ operations, isSearch, searchOperations, cleanCallback, order, actionEdit }) => {
   const [tableData, setTableData] = useState([])

   const EDITAR_OPERACION = useHasOperation(OPERACIONES_OPERACION.EDITAR)
   const VER_CODIGO = useHasOperation(OPERACIONES_OPERACION.VER_CODIGO)

   const columns = [
      {
         title: 'NOMBRE OPERACIÓN',
         field: 'name',
         align: 'center',
         sorting: !!isSearch,
         customSort: () => 0,
         defaultSort: order,
         render: rowData => <TableCell text={rowData?.name} />
      },
      {
         title: 'TIPO OPERACIÓN',
         field: 'type',
         align: 'center',
         sorting: false
      },
      {
         title: 'DESCRIPCIÓN OPERACIÓN',
         field: 'description',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.description} />
      },
      {
         title: 'ESTADO OPERACIÓN',
         field: 'status',
         align: 'center',
         sorting: false,
         render: rowData => {
            if (rowData.status) {
               // Este If es para que no muestre status en filas collabsables
               return rowData.status === 'A' ? <Active /> : <Inactive />
            }
         }
      },
      {
         title: 'NOMBRE FUNCIONALIDAD',
         field: 'functionality.name',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.functionality?.name} />
      },
      {
         title: 'FECHA REGISTRO',
         field: 'createdDate',
         align: 'center',
         sorting: false
      },
      {
         title: 'USUARIO REGISTRO',
         field: 'createdBy',
         align: 'center',
         sorting: false
      }
   ]

   const getOperationTypeNameById = type => VALUES.OPERATION_TYPES.find(option => option.value === type)?.label

   useEffect(() => {
      const collapsibleData = []
      operations?.data?.forEach((operation, index) => {
         let parentId = null
         const changeColor = index % 2 === 0
         operation.types.forEach((type, typeIndex) => {
            if (typeIndex === 0) {
               collapsibleData.push({
                  ...operation,
                  type: getOperationTypeNameById(type),
                  changeColor
               })
               parentId = operation.id
            } else {
               collapsibleData.push({
                  id: operation.id,
                  type: getOperationTypeNameById(type),
                  parentId,
                  changeColor
               })
            }
         })
      })
      setTableData(collapsibleData)
   }, [operations.data])

   const parentChildBinding = (row, rows) => rows.find(a => a.id === row.parentId)

   const actions = [
      EDITAR_OPERACION
         ? rowData => ({
              icon: 'edit',
              tooltip: 'Editar fila',
              hidden: rowData.parentId,
              onClick: (_, rowData) => actionEdit(rowData)
           })
         : null
   ]

   return (
      <ResultsTable
         columns={columns}
         tableData={{
            data: tableData,
            pageSize: operations.pageSize,
            totalRows: operations.totalRows,
            pageNumber: operations.pageNumber
         }}
         isSearch={isSearch}
         searchCallback={searchOperations}
         cleanCallback={cleanCallback}
         actionEdit={actionEdit}
         order={order}
         parentChildData={parentChildBinding}
         customActions={actions}
         enableKey={VER_CODIGO}
      />
   )
}

export default memo(OperationTable)
